import {Auditoria} from "../../bibliotecaPjus/models/comum.models";
import {IFormulario, IModel} from "../../bibliotecaPjus/models/contrato.models";
import {Negociacao} from "./negociacao.model";
import {AbstractControl, FormControl, FormGroup, ValidatorFn, Validators} from "@angular/forms";
import {TipoArquivoPermitido, TipoArquivoPermitidoEnum} from "../enum/tipo-arquivo-permitido.enum";

export class EnvioCnds extends Auditoria implements IModel, IFormulario {

  nome: string
  propostaId: string;
  documentoId: number;
  base64: string;
  extensaoArquivo: string;
  nomeExterno: string;
  url: string;
  statusDocumento: string;
  tipoDocumento: string;
  marcadoParaRevisao: boolean;

  form: FormGroup;

  constructor(other?: any) {
    super(other);
    if (other) {
      this.propostaId = other.propostaId;
      this.base64 = other.base64;
      this.extensaoArquivo = other.extensaoArquivo;
      this.nomeExterno = other.nomeExterno;
      this.url = other.url;
      this.documentoId = other.documentoId;
      this.statusDocumento = other.statusDocumento;
      this.marcadoParaRevisao = other.marcadoParaRevisao;
      this.nome = other.nome;
      this.tipoDocumento = other.tipoDocumento;
    }
  }

  get asForm(): FormGroup {
    if (this.form == null) {
      this.form = new FormGroup({
        propostaId: new FormControl(this.propostaId, [Validators.required]),
        base64: new FormControl(this.base64, [Validators.required, this.tamanhoArquivoValidator(200)]),
        extensaoArquivo: new FormControl(this.extensaoArquivo, [Validators.required, this.docFileValidator()]),
        nomeExterno: new FormControl(this.nomeExterno, [Validators.required]),
        tipoDocumento: new FormControl(this.tipoDocumento, [Validators.required]),
      });
    }
    return this.form;
  }

  updateForm(other): void {
    this.form.patchValue(other);
  }

  docFileValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      const isDocValid = control.value ? Object.values(TipoArquivoPermitido).map(String).
                                  map(value => value.toLowerCase()).
                                  includes(control.value?.toLowerCase()) : null;
      return isDocValid ? null : { 'notDoc': { value: control.value }};
    };
  }

  tamanhoArquivoValidator(maxSizeInMB: number = 10): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      const fileSizeInBytes = control.value ? (control.value.length * (3/4)) : 0;
      const fileSizeInMB = fileSizeInBytes / (1024 * 1024);
      return fileSizeInMB > maxSizeInMB ? { 'fileSizeExceeded': { value: control.value }} : null;
    };
  }
}

